import React from "react";

import config from "../../Config";
import WithLogin from "../../components/WithLogin";

class BuyBids extends React.Component{

	componentWillMount(){
		window.location.href = `${config.BILLING_URL}/billing`;
		// window.location.replace(`${config.BILLING_URL}/billing`);
	}

	render(){
		return null;
	}
}

export default WithLogin(BuyBids);


// WEBPACK FOOTER //
// ./src/views/BuyBids/index.js